import { Stack, TableCell, TableRow, Typography } from "@mui/material";
import { HeadquartersType } from "../../../../../domain/models/executive-summary/executive-summary-type";
import { DownloadJSONExecutive } from "../../../../../domain/models/executive-summary/download-json-executive";
import { useEffect } from "react";

type Props = {
  data: HeadquartersType;
  month: number;
  year: number;
  channelPaisaColumn: boolean;
  channelPayColumn: boolean;
  areaName: string;
  downloadJSON: DownloadJSONExecutive[];
  open: boolean;
};

const HqWiseExecutive: React.FC<Props> = ({
  data,
  channelPaisaColumn,
  channelPayColumn,
  month,
  areaName,
  downloadJSON,
  open,
  year,
}) => {
  const channelPayData = data.channelPay.previous_months.find(
    (d) => d.month === month
  );
  const channelPaisaData = data.channelPaisa.previous_months.find(
    (d) => d.month === month
  );

  const currentMonth = new Date();

  const getMonthName = (monthNumber: number) => {
    const date = new Date();
    date.setFullYear(2000, monthNumber - 1, 1);
    return date.toLocaleString("default", { month: "long" }).toUpperCase();
  };

  const jsonData: DownloadJSONExecutive = {
    role: "TSO",
    area_name: areaName,
    hq_name: data.hq_name,
    total_target: `₹${data.target}`,
    target_orders: data.orders_target,
    total_sales: `₹${data.sales}`,
    sales_order: data.orders,
    percentage: `${data.percentage}%`,
    growth: `${data.growth}%`,
    cpay_invoices: `₹${data.channelPay.current_month.invoices}`,
    cpay_invoices_count: data.channelPay.current_month.invoices_count,
    cpay_orders: `₹${data.channelPay.current_month.order}`,
    cpay_orders_count: data.channelPay.current_month.order_count,
    cpay_active: `${data.channelPay.current_month.active}/${data.channelPay.current_month.total}`,
    cpaisa_invoices: `₹${data.channelPaisa.current_month.invoices}`,
    cpaisa_invoices_count: data.channelPaisa.current_month.invoices_count,
    cpaisa_orders: `₹${data.channelPaisa.current_month.order}`,
    cpaisa_orders_count: data.channelPaisa.current_month.order_count,
    cpaisa_active: `${data.channelPaisa.current_month.active}/${data.channelPaisa.current_month.total}`,
  };
  const channelPayJsonData: DownloadJSONExecutive = {
    role: "TSO",
    area_name: areaName,
    hq_name: data.hq_name,
    total_target: `₹${data.target}`,
    target_orders: data.orders_target,
    total_sales: `₹${data.sales}`,
    sales_order: data.orders,
    percentage: `${data.percentage}%`,
    growth: `${data.growth}%`,
    prev_month: getMonthName(month),
    prev_cpay_invoices: `₹${channelPayData?.invoices}`,
    prev_cpay_invoices_count: channelPayData?.invoices_count,
    prev_cpay_orders: `₹${channelPayData?.order}`,
    prev_cpay_orders_count: channelPayData?.order_count,
    prev_cpay_active: `${channelPayData?.active}/${channelPayData?.total}`,
    curr_month: getMonthName(currentMonth.getMonth() + 1),
    curr_cpay_invoices: `₹${data.channelPay.current_month.invoices}`,
    curr_cpay_invoices_count: data.channelPay.current_month.invoices_count,
    curr_cpay_orders: `₹${data.channelPay.current_month.order}`,
    curr_cpay_orders_count: data.channelPay.current_month.order_count,
    curr_cpay_active: `${data.channelPay.current_month.active}/${data.channelPay.current_month.total}`,
  };
  const channelPaisaJsonData: DownloadJSONExecutive = {
    role: "TSO",
    area_name: areaName,
    hq_name: data.hq_name,
    total_target: `₹${data.target}`,
    target_orders: data.orders_target,
    total_sales: `₹${data.sales}`,
    sales_order: data.orders,
    percentage: `${data.percentage}%`,
    growth: `${data.growth}%`,
    prev_month: getMonthName(month),
    prev_cpaisa_invoices: `₹${channelPaisaData?.invoices}`,
    prev_cpaisa_invoices_count: channelPaisaData?.invoices_count,
    prev_cpaisa_orders: `₹${channelPaisaData?.order}`,
    prev_cpaisa_orders_count: channelPaisaData?.order_count,
    prev_cpaisa_active: `${channelPaisaData?.active}/${channelPaisaData?.total}`,
    curr_month: getMonthName(currentMonth.getMonth() + 1),
    curr_cpaisa_invoices: `₹${data.channelPaisa.current_month.invoices}`,
    curr_cpaisa_invoices_count: data.channelPaisa.current_month.invoices_count,
    curr_cpaisa_orders: `₹${data.channelPaisa.current_month.order}`,
    curr_cpaisa_orders_count: data.channelPaisa.current_month.order_count,
    curr_cpaisa_active: `${data.channelPaisa.current_month.active}/${data.channelPaisa.current_month.total}`,
  };
  downloadJSON.push(jsonData);

  useEffect(() => {
    const index = downloadJSON.findIndex(
      (item) =>
        item.role === "TSO" &&
        item.area_name === areaName &&
        item.hq_name === data.hq_name
    );
    if (index) {
      if (!channelPaisaColumn && !channelPayColumn) {
        downloadJSON[index] = jsonData;
      } else if (channelPayColumn) {
        downloadJSON[index] = channelPayJsonData;
      } else if (channelPaisaColumn) {
        downloadJSON[index] = channelPaisaJsonData;
      }
      // } else {
      //   if (!channelPaisaColumn && !channelPayColumn) {
      //     downloadJSON.push(jsonData);
      //   } else if (channelPayColumn) {
      //     downloadJSON.push(channelPayJsonData);
      //   } else if (channelPaisaColumn) {
      //     downloadJSON.push(channelPaisaJsonData);
      //   }
    }
  }, [channelPaisaColumn, channelPayColumn]);
  return (
    <>
      {open && (
        <TableRow>
          <TableCell padding="none" />
          <TableCell padding="none" color="#5E5ADB">
            {areaName}
          </TableCell>
          <TableCell padding="none" color="#5E5ADB">
            {data.hq_name}
          </TableCell>
          <TableCell padding="none" />
          <TableCell padding="none" align="center">
            <Typography fontSize={13}>₹{data.target}</Typography>
            <Typography fontSize={11} color={"gray"}>
              {data.orders_target} ORDERS
            </Typography>
          </TableCell>
          <TableCell padding="none" align="center">
            <Typography fontSize={13}>₹{data.sales}</Typography>
            <Typography fontSize={11} color={"gray"}>
              {data.orders} ORDERS
            </Typography>
          </TableCell>
          <TableCell padding="none" align="center">
            {data.percentage}%
          </TableCell>
          <TableCell padding="none" align="center">
            {data.growth}%
          </TableCell>
          {!channelPaisaColumn && !channelPayColumn && (
            <>
              <TableCell padding="none" />
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPay.current_month.invoices}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPay.current_month.invoices_count} INVOICES
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPay.current_month.order}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPay.current_month.order_count} ORDERS
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Stack direction={"row"} justifyContent={"center"}>
                  <Typography color={"green"} fontWeight={500} fontSize={15}>
                    {data.channelPay.current_month.active}
                  </Typography>
                  /{data.channelPay.current_month.total}
                </Stack>
              </TableCell>
              <TableCell padding="none" />
              <TableCell padding="none" />
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPaisa.current_month.invoices}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPaisa.current_month.invoices_count} INVOICES
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPaisa.current_month.order}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPaisa.current_month.order_count} ORDERS
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Stack direction={"row"} justifyContent={"center"}>
                  <Typography color={"green"} fontWeight={500} fontSize={15}>
                    {data.channelPaisa.current_month.active}
                  </Typography>
                  <Typography fontSize={15}>
                    /{data.channelPaisa.current_month.total}
                  </Typography>
                </Stack>
              </TableCell>
            </>
          )}
          {channelPaisaColumn && (
            <>
              <TableCell padding="none" />
              <TableCell padding="none" />
              <TableCell padding="none" align="center">
                {channelPaisaData && (
                  <>
                    <Typography fontSize={13}>
                      ₹{channelPaisaData.invoices}
                    </Typography>
                    <Typography fontSize={11} color={"gray"}>
                      {channelPaisaData.invoices_count} INVOICES
                    </Typography>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                {channelPaisaData && (
                  <>
                    <Typography fontSize={13}>
                      ₹{channelPaisaData.order}
                    </Typography>
                    <Typography fontSize={11} color={"gray"}>
                      {channelPaisaData.order_count} ORDERS
                    </Typography>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                {channelPaisaData && (
                  <>
                    <Stack direction={"row"} justifyContent={"center"}>
                      <Typography
                        color={"green"}
                        fontWeight={500}
                        fontSize={15}
                      >
                        {channelPaisaData.active}
                      </Typography>
                      /{channelPaisaData.total}
                    </Stack>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPaisa.current_month.invoices}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPaisa.current_month.invoices_count} INVOICES
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPaisa.current_month.order}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPaisa.current_month.order_count} ORDERS
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Stack direction={"row"} justifyContent={"center"}>
                  <Typography color={"green"} fontWeight={500} fontSize={15}>
                    {data.channelPaisa.current_month.active}
                  </Typography>
                  <Typography fontSize={15}>
                    /{data.channelPaisa.current_month.total}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell padding="none" />
            </>
          )}
          {channelPayColumn && (
            <>
              <TableCell padding="none" />
              <TableCell padding="none" align="center">
                {channelPayData && (
                  <>
                    <Typography fontSize={13}>
                      ₹{channelPayData.invoices}
                    </Typography>
                    <Typography fontSize={11} color={"gray"}>
                      {channelPayData.invoices_count} INVOICES
                    </Typography>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                {channelPayData && (
                  <>
                    <Typography fontSize={13}>
                      ₹{channelPayData.order}
                    </Typography>
                    <Typography fontSize={11} color={"gray"}>
                      {channelPayData.order_count} ORDERS
                    </Typography>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                {channelPayData && (
                  <>
                    <Stack direction={"row"} justifyContent={"center"}>
                      <Typography
                        color={"green"}
                        fontWeight={500}
                        fontSize={15}
                      >
                        {channelPayData.active}
                      </Typography>
                      <Typography fontSize={15}>
                        /{channelPayData.total}
                      </Typography>
                    </Stack>
                  </>
                )}
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPay.current_month.invoices}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPay.current_month.invoices_count} INVOICES
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Typography fontSize={13}>
                  ₹{data.channelPay.current_month.order}
                </Typography>
                <Typography fontSize={11} color={"gray"}>
                  {data.channelPay.current_month.order_count} ORDERS
                </Typography>
              </TableCell>
              <TableCell padding="none" align="center">
                <Stack direction={"row"} justifyContent={"center"}>
                  <Typography color={"green"} fontWeight={500} fontSize={15}>
                    {data.channelPay.current_month.active}
                  </Typography>
                  <Typography fontSize={15}>
                    /{data.channelPay.current_month.total}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell padding="none" />
              <TableCell padding="none" />
            </>
          )}
        </TableRow>
      )}
    </>
  );
};

export default HqWiseExecutive;
